let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aDUXT")).then(() => parcelRequire('5YVNj'));